import { Resource } from '@esg/esg-global-types';

/**
 * Get the specific GRI standard from the compliance reference data of a question to use for resource linking.
 * @param {string} compliance_ref The compliance reference string from the Readiness Gauge Question to parse.
 * @returns {string}
 */
const getGRIStandardFromRef = (compliance_ref: string): string => {
  return compliance_ref.toLowerCase().replaceAll('gri ', '').split('-')[0];
};

/**
 * Get the URL path of the relevant resource for a GRI compliance reference if exists, if not, link to Resource Centre home page.
 * @param {string} compliance_ref The compliance reference string from the Readiness Gauge question to find the resource for.
 * @param {Array<Resource>} resources Resources to search through for the relevant GRI link.
 * @returns {string}
 */
export const getGRIResourceLink = (compliance_ref: string, resources: Array<Resource>): string => {
  const gri_resource: Resource | undefined = resources.find(
    (resource: Resource) =>
      resource.alias?.toLowerCase().replaceAll('gri ', '') === getGRIStandardFromRef(compliance_ref)
  );
  return gri_resource ? `/resources/details?resource=${gri_resource.id}` : '/resources/explore';
};

/**
 * Get the URL path of the relevant resource for an SDG reference if exists, if not, link to Resource Centre home page.
 * @param {string} sdg_ref The SDG reference of the Readiness Gauge question to find the relevant resource for.
 * @param {Array<Resource>} resources Resources to search through to for the relevant SDG link.
 * @returns {string}
 */
export const getSDGResourceLink = (sdg_ref: string, resources: Array<Resource>): string => {
  const sdg_resource: Resource | undefined = resources.find(
    (resource: Resource) => resource.alias?.toLowerCase().replaceAll('sdg ', '') === sdg_ref
  );
  return sdg_resource ? `/resources/details?resource=${sdg_resource.id}` : '/resources/explore';
};
